var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    stroke: "#5A5A5A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 10.7832C23.1836 10.0293 22.5898 9.43555 21.8379 9.23438C20.4727 8.86719 15 8.86719 15 8.86719C15 8.86719 9.52734 8.86719 8.16211 9.23242C7.4082 9.43359 6.81641 10.0273 6.61523 10.7812C6.25 12.1484 6.25 15 6.25 15C6.25 15 6.25 17.8516 6.61523 19.2168C6.81641 19.9707 7.41016 20.5645 8.16211 20.7656C9.52734 21.1328 15 21.1328 15 21.1328C15 21.1328 20.4727 21.1328 21.8379 20.7656C22.5918 20.5645 23.1836 19.9707 23.3848 19.2168C23.75 17.8516 23.75 15 23.75 15C23.75 15 23.75 12.1484 23.3848 10.7832ZM13.2617 17.6172V12.3828L17.793 14.9805L13.2617 17.6172Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube2);
export default __webpack_public_path__ + "static/media/icon_youtube_2.53bca74821882fd12516b8b488606623.svg";
export { ForwardRef as ReactComponent };